module.exports = __webpack_public_path__ + "static/media/rond-vert.559b4e96.png";